/**
 * Presentation only. The bucket vocabulary itself is served by the backend on
 * `bid_progress_options` — do not hardcode a list of buckets here, or this
 * becomes yet another copy of a fact that already has an owner.
 */
export interface ChipStyle {
    label: string;
    classes: string;
}

const MUTED = 'bg-secondary-subtle text-secondary';

export const BID_PROGRESS_CHIPS: { [bucket: string]: ChipStyle } = {
    'Awaiting bids':      { label: 'awaiting',  classes: 'bg-warning-subtle text-warning' },
    'Draft':              { label: 'draft',     classes: 'bg-warning-subtle text-warning' },
    'Pending submission': { label: 'pending',   classes: 'bg-info-subtle text-info' },
    'Submitted':          { label: 'submitted', classes: 'bg-success-subtle text-success' },
    'Declined':           { label: 'declined',  classes: 'bg-danger-subtle text-danger' },
    'Expired':            { label: 'expired',   classes: 'bg-danger-subtle text-danger' },
    'Withdrawn':          { label: 'withdrawn', classes: MUTED },
};

export function chipLabel(bucket: string): string {
    return BID_PROGRESS_CHIPS[bucket] ? BID_PROGRESS_CHIPS[bucket].label : bucket;
}

export function chipClass(bucket: string): string {
    return BID_PROGRESS_CHIPS[bucket] ? BID_PROGRESS_CHIPS[bucket].classes : MUTED;
}
